import { motion } from "framer-motion";
import { fadeUp, viewportOnce } from "../lib/motion";

const SPEC_CATEGORIES = [
    "FLOORING",
    "WALL FINISHES",
    "CEILINGS",
    "KITCHENS & CABINETRY",
    "BATHROOM FITTINGS",
    "DOORS & WINDOWS",
    "LIGHTING",
    "PLUMBING FIXTURES",
    "ROOFING",
    "EXTERNAL FINISHES",
    "PAVING",
    "RENEWABLE ENERGY",
];

const FinishesSpecBand = () => (
    <section
        data-testid="finishes-spec-band"
        className="relative border-y border-white/10 bg-surface/50 py-20 lg:py-28"
    >
        <div className="mx-auto max-w-[1600px] px-6 md:px-10 lg:px-16">
            <motion.div
                variants={fadeUp}
                initial="hidden"
                whileInView="show"
                viewport={viewportOnce}
                className="grid gap-10 lg:grid-cols-12"
            >
                <div className="lg:col-span-7">
                    <div className="flex flex-wrap items-center gap-4">
                        <p className="flex items-center gap-3 font-mono text-[13px] tracking-[0.3em] text-mist">
                            <span className="h-1.5 w-1.5 bg-accent" />
                            FINISHES, FIXTURES & SPECIFICATIONS
                        </p>
                        <span className="border border-white/20 px-2 py-0.5 font-mono text-[13px] tracking-[0.22em] text-mist">
                            PLANNED — BEING DEVELOPED FOR THE PILOT
                        </span>
                    </div>
                    <h2 className="mt-6 max-w-xl font-display text-3xl font-semibold leading-[1.12] text-white md:text-4xl">
                        Explore finishes and specifications with your budget in
                        mind.
                    </h2>
                    <p className="mt-5 max-w-xl text-[16px] leading-relaxed text-mist">
                        Compare potential material, fixture and finish choices
                        and see how specification decisions can affect the
                        estimated cost of your planned home. Where supplier or
                        pricing information is not verified, none is shown.
                    </p>
                </div>
                <div className="lg:col-span-5">
                    <div
                        data-testid="spec-categories"
                        className="flex flex-wrap gap-2.5"
                    >
                        {SPEC_CATEGORIES.map((c) => (
                            <span
                                key={c}
                                className="border border-white/15 px-3.5 py-2 font-mono text-[13px] tracking-[0.2em] text-mist"
                            >
                                {c}
                            </span>
                        ))}
                    </div>
                    <p className="mt-6 font-mono text-[13px] leading-relaxed tracking-[0.18em] text-cad">
                        SPECIFICATION EXPLORATION IS PLANNED — NO STOCK
                        AVAILABILITY OR PRICES ARE SHOWN UNTIL VERIFIED
                    </p>
                </div>
            </motion.div>
        </div>
    </section>
);

export default FinishesSpecBand;
